import axios from "axios";
import jwt_decode from "jwt-decode";
const request = axios.create({
  baseURL:
    // "http://127.0.0.1:8000/",
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/recruitment/", // Dev Gateway
    // "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/recruitment/", // Staging gateway
  "https://gateway.hire3x.com/recruitment/" // Production gateway
  // "http://127.0.0.1:8000/" // Local Server
});
const requestrbac = axios.create({
  baseURL:
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac/access/", // Dev Gateway
  "https://gateway.hire3x.com/rbac/access/", // Staging gateway
  // "https://gateway.hire3x.com/rbac/access/" // Production gateway
  // baseURL: "http://rbac.simplifymycareer.com/access/access/",
  // baseURL: "http://127.0.0.1:8002/access/",
});

requestrbac.interceptors.response.use((response) => {
  return response;
});

request.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = "Bearer " + getToken();
    // config.headers["userID"] = getProcessedToken();

    return config;
  },
  (error) => {
    // Do something with request error
    return error;
  }
);
request.interceptors.response.use((response) => {
  return response;
});
//response
request.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Do something with request error
    if (
      error.response == undefined ||
      error.response.status == 403 ||
      error.response.status == 401
    ) {
      // await getNewAccessToken();
      error.config.headers["Authorization"] = "bearer " + getToken();
      return axios(error.config);
    } else {
      return error.response;
    }
    // if (error.response.status === 403 || error.response.status === 401) {
    // } else {
    //   return error;
    // }
  }
);
const SSOService = axios.create({
    baseURL:
    // "http://sso.simplifycv.com/", // Development
    // "https://auth.simplifymycareer.com/", // Staging
    "https://auth.hire3x.com/" // Production
  });

const notificationAuth = axios.create({
  // baseURL: "https://notification.simplifycv.com/", // Dev Gateway
  // baseURL:"https://notification.simplifymycareer.com/", // Staging
  baseURL: "https://notification.hire3x.com/", // Production
});

const KeynodeService = axios.create({
	baseURL: "https://keynode.hire3x.com/",
});

  const websiteRequest = axios.create({
    // baseURL: "https://api-website.simplifymycareer.com",
    baseURL: "https://api-website.hire3x.com",
  });
  
   notificationAuth.interceptors.request.use(
    (config) => {
      // config.headers["Authorization"] = "Bearer " + getToken();
      config.headers["userID"] = getProcessedToken();
      // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
      // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";
  
      return config;
    },
    (error) => {
      // Do something with request error
      return error;
    }
  );

  websiteRequest.interceptors.request.use(
    (config) => {
      // config.headers["Authorization"] = "Bearer " + getToken();
      config.headers["userID"] = getProcessedToken();
      // config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
      // config.headers["userID"] = "e562e893-3ed8-4073-9576-10373bc3e260";
  
      return config;
    },
    (error) => {
      // Do something with request error
      return error;
    }
  );
  const getToken = () => {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "accessToken") {
        return cur[1];
      }
    }
    // return localStorage.getItem("vue_token");
  };
 export const getProcessedToken =() => {
    var decoded = jwt_decode(getToken());
    return decoded.sub;
  }
  // Get token from localstorage


const SysToken = axios.create({
  baseURL:
    // "http://keynode.simplifycv.com/" // Development

    // "https://keynode.simplifymycareer.com/" // Staging

  "https://keynode.hire3x.com/" // Production
});
const ServiceCandidate = axios.create({
  baseURL:
    // "http://localhost:8001/", // Development
    "https://candidate-api.hire3x.com/",
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
    // "https://gateway.simplifymycareer.com/candidate/", // Staging

});

const apiWebsiteRequest = axios.create({
    baseURL: "https://api-website.hire3x.com",
  });

export{
    SSOService,
    SysToken,
    ServiceCandidate,
    websiteRequest,
    request,
    apiWebsiteRequest,
    requestrbac,
    notificationAuth,
    KeynodeService
}